import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from "@mui/material";
import React, { useState } from "react";

import { styled } from "@mui/material/styles";
import { withRouter } from "react-router";
import { compose } from "underscore";
import { DASHBOARD } from "../redux/constant";

import { CustomButton } from "../../components";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-scrollPaper': {
    padding: '0 16px',
  },
  '& .MuiDialog-paperFullWidth': {
    minWidth: '100%',
  },
}));

const DepositSuccessModal = ({ history, match: { params } }) => {
  const from = params.from;

  const [isOpenAlert, setOpenAlert] = useState(true);

  return (
    <StyledDialog
      fullWidth
      open={isOpenAlert}
      onClose={() => setOpenAlert(false)}
    >
      <DialogTitle sx={{ padding: "24px 16px 8px" }}>
        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: "700",
            lineHeight: 1.4,
            color: "#000",
          }}
        >
          Set up auto deposit, a powerful way to help you acheive your goal on
          time
        </Typography>
      </DialogTitle>
      <DialogContent style={{ margin: 0, padding: 0 }}>
        <DialogActions style={{ margin: 0 }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              margin: "24px 16px 16px",
              padding: 0,
            }}
          >
            <CustomButton
              text="Set Up Auto Deposit"
              variant="contained"
              color="#fff"
              backgroundColor="#1278CC"
              onClick={() =>
                history.push(`/make-deposit/${from}/success/auto-deposit`)
              }
            />
            <Button
              onClick={() => {
                setOpenAlert(false);
                from === DASHBOARD && history.push("/dashboard");
              }}
              sx={{
                color: "#0076CF",
                marginTop: "16px",
                padding: 0,
                textTransform: "capitalize",
                lineHeight: "20px",
                fontSize: "16px",
                marginLeft: "0 !important"
              }}
            >
              Maybe Later
            </Button>
          </div>
        </DialogActions>
      </DialogContent>
    </StyledDialog>
  );
};

export default compose(withRouter)(DepositSuccessModal);
